/**
 * Where a record lives, by object key.
 *
 * Written here rather than derived from the object catalogue because the
 * catalogue is a server module and the routes are the web app's own. The two
 * can drift, so the fallback is a link that goes nowhere useful rather than a
 * crash - and the check that every screen is reachable is what catches a route
 * that stops existing.
 */
const ROUTES: Record<string, string> = {
  contact: '/contacts',
  account: '/accounts',
  lead: '/leads',
  deal: '/deals',
  product: '/products',
};

export function recordHref(objectKey: string, recordId: string): string {
  const base = ROUTES[objectKey];
  return base ? `${base}/${recordId}` : `/${objectKey}/${recordId}`;
}
